import { FC } from "react";
import styles from "./UserAvatar.module.scss";
import clsx from "clsx";

interface UserAvatarProps {
  image: null | undefined | string;
  fio: string;
  small?: boolean;
}

export const UserAvatar: FC<UserAvatarProps> = ({
  image,
  fio,
  small = false,
}) => {
  const splittedPartsArr: string[] = fio ? fio.split(" ") : [" ", " "];
  const initials =
    splittedPartsArr.length > 1
      ? splittedPartsArr[0][0] + splittedPartsArr[1][0]
      : splittedPartsArr[0][0];

  return (
    <div className={clsx(styles.userAvatar, { [styles.small]: small })}>
      {image ? (
        <img src={image} />
      ) : (
        <div className={styles.emptyPhoto}>
          <span>{initials.toUpperCase()}</span>
        </div>
      )}
    </div>
  );
};
